// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function userCreate(params: {
  email: string
  password1: string
  password2: string
}) {
  return http<{
    user: {
      id: number
      name: string
      avatar_url: string
      email: string
      theme_day: "light" | "dark" | "dark_dimmed" | "autumn" | "solarized"
      theme_night: "light" | "dark" | "dark_dimmed" | "autumn" | "solarized"
      theme_mode: "single" | "sync_with_system"
      schedule_team: number | null
      calendar_id: number | null
    }
  }>({
    url: "/api/v1/auth/registration/",
    method: "post",
    params,
  })
}
